export default __webpack_public_path__ + "static/media/linkedin-icon.da2f76e5.svg";